<template>
    <portal to="body-content">
        <!-- Modal -->
        <div class="modal fade reset-my-password-modal" id="forgotPasswordModal" tabindex="-1" role="dialog" aria-labelledby="forgotPasswordModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="forgotPasswordModalLabel">Forgot Your Password?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <svg class="close-2"><use xlink:href="#close-2"></use></svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="/password/email" @submit.prevent="submit">

                            <div class="form-row align-items-center mb-4">

                                <div class="col-sm-12 col-md-6 offset-md-3 my-1">
                                    <input type="text"
                                           v-model="form.email"
                                           name="email"
                                           autocapitalize="off"
                                           placeholder="Enter Email/Username"
                                           aria-label="Enter Email or Username"
                                           class="form-control">
                                    <div class="error-message" v-if="form.errors.email" v-text="form.errors.email"></div>
                                </div>

                            </div>

                            <button type="submit" class="btn-black" :class="{'disabled' : isDisabled}" :disabled="isDisabled" aria-label="Login Button">
                                Reset My Password <svg class="arrow-right-2"><use xlink:href="#arrow-right-2"></use></svg>
                            </button>

                            <p class="alternative-text">
                                Already have a <button @click="loginInstead()" type="button" aria-label="Forgot Password Button">login</button>?
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </portal>
</template>
<script>

import EmailValidator from "email-validator";
import Form from '@/classes/Form'

export default {

    data() {
        return {
            form: new Form({
                email: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post('/password/email')
                .then(response => {
                    Toast.timer(response.success).then(() => {
                        $('#forgotPasswordModal').modal('toggle')
                    })
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        loginInstead(){
            $('#forgotPasswordModal').modal('toggle')
            $('#loginModal').modal('toggle')
        }
    },

    computed:{
        isDisabled(){
            return this.form.isSubmitted;
            // return (this.form.email == '' || this.form.password == '' || !EmailValidator.validate(this.form.email))
        }
    }
}
</script>
